module.exports = __webpack_public_path__ + "static/media/entroll_icon.7ea6c2e5.svg";